module.exports = __webpack_public_path__ + "img/icon_minus.7216d754.svg";